export const GET_PROJECT_DATA_REQUEST = "GET_PROJECT_DATA_REQUEST" 
export const GET_PROJECT_DATA_SUCCESS = "GET_PROJECT_DATA_SUCCESS" 
export const GET_PROJECT_DATA_FAILURE = "GET_PROJECT_DATA_FAILURE" 

export const FILTER_PROJECT_DATA_REQUEST = "FILTER_PROJECT_DATA_REQUEST" 
export const FILTER_PROJECT_DATA_SUCCESS = "FILTER_PROJECT_DATA_SUCCESS" 
export const FILTER_PROJECT_DATA_FAILURE = "FILTER_PROJECT_DATA_FAILURE"

export const SORT_DATA_REQUEST = "SORT_DATA_REQUEST"
export const SORT_DATA_SUCCESS = "SORT_DATA_SUCCESS"
export const SORT_DATA_FAILURE = "SORT_DATA_FAILURE"


// nav bar datatypes************************
export const GET_NAVBAR_DATA_REQUEST = "GET_NAVBAR_DATA_REQUEST" 
export const GET_NAVBAR_DATA_SUCCESS = "GET_NAVBAR_DATA_SUCCESS" 
export const GET_NAVBAR_DATA_FAILURE = "GET_NAVBAR_DATA_FAILURE" 

